export default __webpack_public_path__ + "static/media/complementary--camera--g4.5bcf9af2.png";